import {
  Box,
  Typography,
  Stack,
  Chip,
  Divider,
  IconButton,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useEffect, useState } from "react";
import { getVehicleAlerts } from "../../services/alertService";

interface Props {
  vehicleId: string;
}

export default function VehicleAlerts({ vehicleId }: Props) {
  const [alerts, setAlerts] = useState<any[]>([]);

  useEffect(() => {
    if (!vehicleId) return;

    getVehicleAlerts(vehicleId).then(setAlerts);
  }, [vehicleId]);

  if (!alerts.length) {
    return (
      <Typography variant="body2" sx={{ opacity: 0.7 }}>
        No alerts for today
      </Typography>
    );
  }

  return (
    <Stack spacing={1.2}>
      {alerts.map(alert => (
        <Box
          key={alert.id}
          sx={{
            p: 1.2,
            borderRadius: 1,
            backgroundColor: getBg(alert.severity),
            border: "1px solid rgba(255,255,255,0.1)",
          }}
        >
          <Stack direction="row" justifyContent="space-between">
            <Chip
              size="small"
              label={alert.severity}
              color={getColor(alert.severity)}
            />

            {alert.lat && alert.lng && (
              <IconButton
                size="small"
                onClick={() =>
                  window.open(
                    `https://www.google.com/maps?q=${alert.lat},${alert.lng}`,
                    "_blank"
                  )
                }
              >
                <LocationOnIcon fontSize="small" />
              </IconButton>
            )}
          </Stack>

          <Typography fontWeight={600}>
            {alert.type}
          </Typography>

          <Typography variant="body2" sx={{ opacity: 0.85 }}>
            {alert.message}
          </Typography>

          <Divider sx={{ my: 0.5 }} />

          <Typography variant="caption">
            {new Date(alert.eventTime).toLocaleString()}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
}

/* ================= HELPERS ================= */

function getColor(severity: string) {
  if (severity === "HIGH") return "error";
  if (severity === "MEDIUM") return "warning";
  return "success";
}

function getBg(severity: string) {
  if (severity === "HIGH") return "rgba(255,0,0,0.08)";
  if (severity === "MEDIUM") return "rgba(255,165,0,0.08)";
  return "rgba(0,255,0,0.08)";
}
